import { useGet } from 'hooks/use-get';
import { Dispatch, FC, memo, SetStateAction } from 'react';
import { useIntl } from 'react-intl';
import titleCase from 'utils/title-case';

import { Box } from '@mui/material';
import Autocomplete from 'components/autocomplete';
import CheckboxSelectItem from 'components/checkbox-select-item';
import FilterSidebar from 'components/filter-sidebar';
import Select from 'components/select';

import ScenarioCreateDialog from 'views/bluviu-nutrition/features/scenarios-v2/components/scenario-create-dialog';

import { getGenerations } from 'views/bluviu-nutrition/features/scenarios-v2/api/generations-get';
import { ScenarioGeneration } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-generation.type';
import { ScenarioState } from 'views/bluviu-nutrition/types/scenario-state.enum';
interface Filters {
  generation: string;
  states: string[];
  searchValue: string;
}
type Props = {
  filters: Filters;
  setFilters: Dispatch<SetStateAction<Filters>>;
};

const PAGE_NAME_ID = 'bluViuNutrition.listScenarios';

const ScenarioListFilter: FC<Props> = ({ filters, setFilters }) => {
  const intl = useIntl();
  const { data: generations } = useGet(['getGenerations'], () => getGenerations());
  const generation = generations?.find((g) => g.displayName === filters.generation);

  const hasActiveFilters = !!filters.generation || filters.states.length > 0;

  const handleClearFilters = () => {
    setFilters({
      generation: '',
      states: [],
      searchValue: '',
    });
  };

  return (
    <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'}>
      <FilterSidebar clearFiltersPlacement="flex-start" clearFilters={handleClearFilters} showClearFilter={hasActiveFilters}>
        <Autocomplete
          label={'Generation'}
          disableCloseOnSelect={false}
          options={generations ?? []}
          value={generation ?? null}
          getOptionLabel={(option) => (option as ScenarioGeneration).displayName}
          onChange={(_, value) =>
            setFilters((prev) => ({ ...prev, generation: (value as ScenarioGeneration | null)?.displayName ?? '' }))
          }
        />
        <Select
          multiple
          label={intl.formatMessage({ id: `${PAGE_NAME_ID}.filters.state.title` })}
          value={filters.states}
          onChange={(event) => {
            setFilters((prev) => ({ ...prev, states: event.target.value as string[] }));
          }}>
          {Object.entries(ScenarioState)?.map((filter) => (
            <CheckboxSelectItem key={filter[1]} checked={filters.states.includes(filter[1])} value={filter[1]}>
              {titleCase(filter[1])}
            </CheckboxSelectItem>
          ))}
        </Select>
      </FilterSidebar>
      <Box>
        <ScenarioCreateDialog />
      </Box>
    </Box>
  );
};

export default memo(ScenarioListFilter);
